module.exports = __webpack_public_path__ + "static/img/10.097f7eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/10.png
// module id = eeKK
// module chunks = 0